var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeHandCrossIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.5px",
    height: "17px",
    viewBox: "0 0 16.5 17",
    style: {
      enableBackground: "new 0 0 16.5 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,11.8c-0.7-0.5-1.4-1.1-2.1-1.7c1.2-1.2,2.4-2.4,3.5-3.8c1.1-1.4,2.1-2.9,3-4.4c0.3-0.5,0.2-1.3-0.4-1.6 c-0.6-0.4-1.3-0.2-1.7,0.3c-1,1.4-1.9,2.8-3,4.1c-1,1.3-2.1,2.6-3.3,3.7C6.8,7.2,5.6,6,4.5,4.8c-1.1-1.3-2.2-2.6-3.3-4 C1,0.6,0.6,0.5,0.3,0.6C0,0.8-0.1,1.2,0.1,1.5C0.9,3.1,1.9,4.6,3,6c1,1.4,2.2,2.8,3.4,4C5.6,10.7,5,11.4,4.2,12 c-1.3,1.1-2.6,2.2-4,3.3C0,15.4,0,15.8,0.1,16.1c0.2,0.3,0.6,0.5,0.9,0.3c1.6-0.8,3.1-1.7,4.6-2.8C6.4,13,7.2,12.4,8,11.7 c0.7,0.7,1.5,1.4,2.3,2c1.4,1.1,2.8,2.2,4.4,3.1c0.5,0.3,1.3,0.2,1.6-0.3c0.4-0.6,0.3-1.3-0.3-1.7C14.6,13.8,13.2,12.8,11.9,11.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeHandCrossIcon);
export default __webpack_public_path__ + "static/media/free-hand-cross-icon.2f2a7aec095893197d11f4d68d3542cb.svg";
export { ForwardRef as ReactComponent };